import React from "react";

const BUBBLE_LEFT_CLASSNAMES = `
  ml-4 relative inline-block max-w-[320px] rounded-[14px] border border-gray-200 bg-white px-3 py-2 text-gray-900
  leading-relaxed shadow-sm
  before:absolute before:left-[-8px] before:top-3 before:h-0 before:w-0
  before:border-y-[8px] before:border-r-[8px] before:border-l-0 before:border-y-transparent before:border-r-gray-200
  after:absolute after:left-[-7px] after:top-3 after:h-0 after:w-0
  after:border-y-[8px] after:border-r-[8px] after:border-l-0 after:border-y-transparent after:border-r-white
`

const BUBBLE_LEFT_NO_ARROW_CLASSNAMES = `
  ml-4 relative inline-block max-w-[320px] rounded-[14px] border border-gray-200 bg-white text-gray-900
  shadow-sm overflow-hidden
`

interface LeftChatBubbleViewProps {
  children: React.ReactNode;
  isNoArrow?: boolean;
  isNoIcon?: boolean;
}

export const LeftChatBubbleView = ({
  children,
  isNoArrow = false,
  isNoIcon = false,
}: LeftChatBubbleViewProps) => (
  <div className="flex flex-row text-left">
    {!isNoIcon && (
      <img
        className={"w-[40px] h-[40px] rounded-3xl"}
        src="/img/icon.jpeg"
        alt="icon"
      />
    )}
    <div className={isNoArrow ? BUBBLE_LEFT_NO_ARROW_CLASSNAMES : BUBBLE_LEFT_CLASSNAMES}>
      {children}
    </div>
  </div>
)
